import { toastNotification } from 'react/utils/utils';
import { triggerNewMessageAudio, parseMessage } from 'react/utils/chatUtils';
import { actionCreators as chatActionCreators } from 'react/api/actions/chat';
import { actionCreators as ticketHubActionsCreators } from 'react/api/actions/ticketHub';
import ChatApiCalls from 'react/services/ChatApiCalls';

export default class ChatEventSource {
  constructor({ chatServerUrl, companyId, userId, userName = null } = {}) {
    this.chatServerUrl = chatServerUrl || '';
    this.companyId = companyId || null;
    this.userId = userId || null;
    this.userName = userName || '';

    this.userNameParam = this.userName ? encodeURIComponent(this.userName) : '';
    this.companyIdPath = this.companyId
      ? encodeURIComponent(this.companyId.toString())
      : this.companyId;

    const url = `${this.chatServerUrl}/streaming/${this.companyIdPath}/${this.userId}`;
    const queryParams = `?name=${this.userNameParam}`;
    const fullUrl = `${url}${queryParams}`;

    this.eventSource = new EventSource(fullUrl);

    this.initListeners();
    this.chatApi = new ChatApiCalls(chatServerUrl, this);
  }

  getUserId() {
    return this.userId;
  }

  getChatApiCalls() {
    return this.chatApi;
  }

  initListeners() {
    this.eventSource.onmessage = (message) => {
      if (message.type === 'message') {
        const frameData = JSON.parse(message.data);

        if (frameData.message && frameData.action) {
          const frameMessage = JSON.parse(frameData.message);
          const { dispatch } = window.globalStore;
          const messageResource = Monet.I18n.getResourcesByKey(
            'Chat.TicketMessage.Alert.Closed.Default'
          );

          switch (frameData.action) {
            case 'ERROR':
              this.logError(frameMessage);
              break;
            case 'RECEIVE_MESSAGE':
            case 'TICKET_RECEIVE_MESSAGE': {
              triggerNewMessageAudio();
              dispatch(chatActionCreators.receiveMessage(frameMessage));

              break;
            }
            case 'MARK_AS_READ': {
              const { id, to, readDate } = frameMessage;
              const chatId = `${Monet.Session.User.id}-${to}`;

              dispatch(
                chatActionCreators.updateSingleMessage({
                  chatId,
                  message: {
                    id,
                    readDate
                  }
                })
              );

              break;
            }
            case 'MARK_AS_RECEIVED': {
              const { id, to, receivedDate } = frameMessage;
              const chatId = `${Monet.Session.User.id}-${to}`;

              dispatch(
                chatActionCreators.updateSingleMessage({
                  chatId,
                  message: {
                    id,
                    receivedDate
                  }
                })
              );
              break;
            }
            case 'RECEIVE_CALL': {
              const { userId } = frameMessage;
              const { name } = Monet.Session.Chat.Users[userId];

              dispatch(
                chatActionCreators.receiveACall({
                  userId,
                  name
                })
              );

              break;
            }
            /** Ticket Events */
            case 'TICKET_ALERT': {
              toastNotification.addToast({
                id: frameMessage.ticketId,
                customElementType: 'ticket-alert',
                data: frameMessage
              });

              break;
            }
            case 'TICKET_HIDE_NOTIFICATION': {
              toastNotification.removeToast({
                id: frameMessage.ticketId
              });

              break;
            }
            case 'TICKET_MARK_AS_READ': {
              const { id, readDate, ticketId } = frameMessage;
              const chatId = ticketId;

              dispatch(
                chatActionCreators.updateSingleMessage({
                  chatId,
                  message: {
                    id,
                    readDate
                  }
                })
              );

              const closedTicketMessage = parseMessage(
                {
                  id: Date.now(),
                  message: messageResource,
                  needTranslation: true
                },
                'external'
              );

              dispatch(
                chatActionCreators.addMessage({
                  chatId,
                  message: closedTicketMessage
                })
              );

              break;
            }
            case 'TICKET_MARK_AS_RECEIVED': {
              const { id, receivedDate, ticketId } = frameMessage;
              const chatId = ticketId;

              dispatch(
                chatActionCreators.updateSingleMessage({
                  chatId,
                  message: {
                    id,
                    receivedDate
                  }
                })
              );

              break;
            }
            case 'TICKET_CLOSED': {
              const { ticketId } = frameMessage;
              const chatId = ticketId;

              dispatch(
                chatActionCreators.updateSingleChat({
                  chatId,
                  ticket: {
                    status: 'CLOSED'
                  }
                })
              );

              dispatch(
                ticketHubActionsCreators.updateTicketStatus({
                  ticketId,
                  status: 'CLOSED'
                })
              );

              const closedTicketMessage = parseMessage(
                {
                  id: Date.now(),
                  message: messageResource,
                  needTranslation: true
                },
                'external'
              );

              dispatch(
                chatActionCreators.addMessage({
                  chatId,
                  message: closedTicketMessage
                })
              );

              break;
            }
            default:
              console.log(
                'ChatEventStream send a message with unknown action',
                frameData
              );
          }
        }
      }
    };
  }

  logError(frameMessage) {
    new Monet.Exception.ReturnError(
      this,
      'Error on show chatAPI',
      frameMessage
    ).console();
  }
}
